import BlockCaseEnd from './BlockCaseEnd';

export type { BlockCaseEndProps, ContactItemProps, CaseEndLink, CaseEndCoworker, CaseEndLinks } from './types';

export default BlockCaseEnd;
